import { IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { BroodRequestPotentialFathersApi, PotentialFathersSearch } from "../../../../api";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalDataTable } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";

export interface IDrupalPotentialFathersListProps {
  broodRequestId: number;
}

export const DrupalPotentialFathersList: React.FunctionComponent<IDrupalPotentialFathersListProps> = ({
  broodRequestId,
}) => {
  const api = useApiService(BroodRequestPotentialFathersApi);
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5, 10, 15],
    pageSize: 5,
  });
  const { totalCount } = tableState;

  const searchFunction = React.useCallback(
    (sObj?) => {
      const sobj = PotentialFathersSearch.fromJS({
        ...sObj,
        broodRequestId: broodRequestId,
        languageId: currentLanguage.languageId,
      });
      return api.baseSearch(sobj);
    },
    [api, broodRequestId, currentLanguage.languageId]
  );

  const { loading } = useSearchApi({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.CompleteName),
        fieldName: "name",
      },
      {
        header: () => t(ETLCodes.Pedigree),
        fieldName: "pedigree",
      },
      {
        header: () => t(ETLCodes.Chip),
        fieldName: "chip",
      },
      {
        header: () => t(ETLCodes.Breed),
        fieldName: "breed",
      },

      {
        header: () => t(ETLCodes.Color),
        fieldName: "color",
      },
    ],
    [t]
  );

  return (
    <DrupalFieldSet title={`${t(ETLCodes.PotentialFathers)} (${totalCount})`}>
      <DrupalDataTable tableState={tableState} loading={loading} columns={columns} />
    </DrupalFieldSet>
  );
};
